import * as actions from '../../constants';
export var changeUserOrganisation = function changeUserOrganisation(organisationId) {
  return {
    type: actions.USER_ORGANISATION_CHANGE,
    currentOrganisation: organisationId
  };
};